<script setup>
import { subStringToType } from '@/utils/index'
import editVisit from './components/editVisit.vue'
import RelateContent from './components/relateContent.vue'
import { defineProps, defineEmits, computed } from 'vue'
import { ActiveLable } from './hooks/config.js'
import useVisitDetail from './hooks/useVisitDetail'
const emit = defineEmits(['jumpTo', 'noDetail'])
const props = defineProps({
  id: {
    type: [String, Number],
    request: true,
    default: '0'
  },
  mode: {
    type: String,
    default: ''
  },
  planType: {
    //   传参优化
    type: Number,
    default: 0
  },
  // 判断用药计划还是随访
  visitPageType: {
    type: Number,
    default: null
  }
  // serialNumber: {
  //   type: String,
  //   default: ''
  // }
})
const columns = computed(() => {
  let tempColumns = ActiveLable[props.planType].visitLabel
  if (props.visitPageType === 1) {
    tempColumns = ActiveLable[props.planType].visitLabel_plan
  }
  if (props.mode && props.planType === 0) {
    const arr = JSON.parse(JSON.stringify(tempColumns))
    if (props.visitPageType === 1) {
      tempColumns = ActiveLable[props.planType].visitLabel_plan
    } else {
      arr.pop()
    }
    return arr
  } else {
    return tempColumns
  }
})
const BASE_LABEL = computed(() => {
  if (props.visitPageType === 1) {
    return ActiveLable[props.planType].baseLabel_plan
  }
  return ActiveLable[props.planType].baseLabel
})
const {
  addPrescriVisible,
  prescriptionId,
  info,
  visitState,
  closeVisit,
  jumpTo,
  handleAddPrescri,
  cancelAddPrescri,
  handleEdit,
  handleCancel,
  editStageVisible,
  currentStageInfo,
  editStage,
  searchPrescriList,
  prescriList,
  addStageVisible,
  addStage,
  handleBtnStatus,
  handleAddStage,
  nextFlowNum,
  showCancelBtn,
  showEditBtn,
  calcEditLabel
} = useVisitDetail(props, emit)
</script>
<template>
  <div class="detail">
    <a-spin :spinning="info.loading">
      <!-- 头部标题 -->
      <p class="head">基本信息</p>
      <!-- 基本信息 -->
      <ul class="detail_label">
        <li
          class="detail_label_info"
          v-for="column in BASE_LABEL"
          :key="column.prop"
          :class="[column.class, { nopadding: column.nopadding, noborder: column.noborder }]"
        >
          <label class="item_label">{{ column.label }}</label>
          <!--随访ID  -->
          <span v-if="column.prop === 'followupPlanId'" class="item_content">
            <auth-img
              v-if="info.base.activityFlag"
              class="lin-guan-tag"
              src="@/assets/img/work-place/lin-guan.png"
              alt="lin-guan"
            />
            {{ info.base[column.prop] || '--' }}
          </span>
          <!-- 随访状态 -->
          <span v-else-if="column.prop === 'planStatus'" class="item_content">
            {{ visitState(info.base[column.prop]) || '--' }}
            <a-popconfirm
              v-if="handleBtnStatus(info.base.planStatus)"
              placement="rightTop"
              title="确定取消随访计划？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="closeVisit"
            >
              <span class="cancel-plan">取消计划</span>
            </a-popconfirm>
          </span>
          <!-- 关联处方 -->
          <span
            v-else-if="column.prop === 'relevancyPrescriptions'"
            class="item_content prescri_btn"
          >
            <a-button
              type="link"
              v-for="(item, index) in info.base[column.prop]"
              @click="jumpTo(subStringToType(item), '0', item)"
              :key="item"
            >
              {{ item }}
              <i v-if="info.base[column.prop].length !== index + 1">,</i>
            </a-button>
            <span
              class="add-prescri"
              @click="addPrescriVisible = true"
              v-if="handleBtnStatus(info.base.planStatus)"
            >
              增加处方
            </span>
          </span>
          <span v-else-if="column.render" class="item_content">
            {{ column.render(info.base[column.prop]) }}
          </span>
          <span v-else class="item_content">
            {{ info.base[column.prop] || '--' }}
          </span>
        </li>
      </ul>
      <div>
        <p class="head head-title z-flex">
          <span>随访阶段</span>
          <span class="addBtn" @click="handleAddStage" v-if="handleBtnStatus(info.base.planStatus)">
            <span>+</span>
            添加
          </span>
        </p>
        <p class="line"></p>
        <a-table
          :rowKey="(record, index) => index"
          :pagination="false"
          :dataSource="info.followUpPlanFlows"
          :columns="columns"
          :transformCellText="({ text }) => text ?? ''"
        >
          <template #flowEditName="{ record }">
            <div v-if="!record.flowEditName">--</div>
            <div v-else class="editName">
              <div class="editLabel" :style="calcEditLabel(record)">
                {{ record.flowEditByType === 1 ? '健管' : '患者' }}
              </div>
              <div>{{ record.flowEditName }}</div>
            </div>
          </template>
          <template #operation="{ record }">
            <div class="z-flex-l">
              <a-button
                class="left_btn"
                type="link"
                @click="handleEdit(record)"
                v-if="showEditBtn(record)"
              >
                编辑
              </a-button>
              <a-button type="link" @click="handleCancel(record.id)" v-if="showCancelBtn(record)">
                取消推送
              </a-button>
              <span v-if="!showEditBtn(record) && !showCancelBtn(record)">--</span>
            </div>
          </template>
          <template #expandedRowRender="{ record }">
            <RelateContent :data="record.stageDetailList" />
          </template>
        </a-table>
      </div>
      <!-- 编辑随访 -->
      <editVisit
        v-model:visible="editStageVisible"
        :currentStageInfo="currentStageInfo"
        @editStage="editStage"
      />
      <!-- 新增随访阶段 -->
      <editVisit
        v-model:visible="addStageVisible"
        :followupPlanId="info.base.followupPlanId"
        @editStage="addStage"
        :nextFlowNum="nextFlowNum"
      />
    </a-spin>
    <a-modal
      v-model:visible="addPrescriVisible"
      title="增加处方"
      :centered="true"
      :mask="true"
      @ok="handleAddPrescri"
      @cancel="cancelAddPrescri"
    >
      <div class="prescri-model z-flex">
        随访计划ID：
        <span>{{ info.base.followupPlanId }}</span>
      </div>
      <div class="prescri-model">
        关联处方ID：
        <span>
          <a-select
            v-model:value="prescriptionId"
            placeholder="请输入处方ID"
            style="width: 100%"
            :filter-option="false"
            @search="searchPrescriList"
            :showSearch="true"
            :allowClear="true"
          >
            <a-select-option
              v-for="item in prescriList"
              :key="item.followupPlanId"
              :value="item.followupPlanId"
            >
              {{ item.srelevancyPrescriptions.join(',') }}
            </a-select-option>
          </a-select>
        </span>
      </div>
    </a-modal>
  </div>
</template>
<style lang="scss" scoped>
%handle-btn {
  border: 1px solid #1890ff;
  border-radius: 2px;
  display: inline-block;
  padding: 2px 8px;
  font-weight: 400;
  font-size: 12px;
  color: #1890ff;
  margin-left: 8px;
  line-height: initial;
  cursor: pointer;
}
.detail {
  .head {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    margin-bottom: 8px;
  }
  .head-title {
    margin-top: 40px;
    .addBtn {
      padding: 3px 14px;
      font-weight: 400;
      font-size: 14px;
      color: #1890ff;
      border: 1px solid #1890ff;
      border-radius: 4px;
      line-height: initial;
      cursor: pointer;
      span {
        margin-right: 12px;
        font-size: 16px;
      }
    }
  }
  .line {
    height: 1px;
    width: 100%;
    margin: 4px 0 15px;
    background: rgba(0, 0, 0, 0.09);
  }
  .left_btn {
    padding-left: initial;
  }
  .editName {
    display: flex;
    align-items: center;
    .editLabel {
      width: 36px;
      line-height: 20px;
      text-align: center;
      margin-right: 10px;
    }
  }
  .detail_label {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    grid-template-rows: repeat(2, minmax(44px, auto));
    list-style: none;
    margin: 0;
    padding-left: 0;
    // grid-gap: 5px 0;
    position: relative;
    margin-bottom: 30px;

    &_info {
      &.large {
        // 左边框所在网格线
        grid-column-start: 2;
        // 右边框所在网格线
        grid-column-end: 4;
      }
      &.huge {
        // 左边框所在网格线
        grid-column-start: 1;
        // 右边框所在网格线
        grid-column-end: 4;
      }
      font-size: 14px;
      padding: 20px 0 20px 16px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;
      // 第一列左对齐
      &.nopadding {
        padding-left: 0;
      }
      // 最后一列不要边框
      &.noborder .item_content:after {
        width: 0;
      }
      &.nobottom {
        border-bottom: 0;
      }
      .item_label {
        font-weight: 550;
        flex-shrink: 0;
        margin-right: 3px;
        color: #999999;
      }
      .item_content {
        font-weight: 400;
        color: #666666;
        flex: auto;
        width: 80%;
        z-index: 2;
        font-weight: bold;
        position: relative;
        &:after {
          content: '';
          display: block;
          width: 1px;
          background: #e8e8e8;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        .cancel-plan {
          @extend %handle-btn;
        }
        .add-prescri {
          @extend %handle-btn;
          color: #ffffff;
          background: #1890ff;
        }
        &.prescri_btn {
          white-space: break-spaces;
          button {
            padding: 0;
          }
        }
      }
    }
  }
}
.prescri-model {
  justify-content: flex-start;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  span {
    color: #333333;
    display: inline-block;
    width: 240px;
    height: 32px;
  }
}
</style>
